import angular from 'angular';

import Component from './action-item-list.component';

const ActionItemList = angular
    .module('control-room.commons.content.components.action-item-list', [])
    .component('crActionItemList', Component);

export default ActionItemList;
